import React, { useEffect, useState } from "react";
import "./../SignIn/signin.scss";
import "../Otp Verify/verification.scss";
import Swiper from "../../components/common/Swiper";
import SwiperText from "../../components/common/SwiperText";
import CardSignin from "../../components/common/Card_signin";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../utils";
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { doSendEmailCode, doVerifyEmailCode } from "../../actions/auth";
import {
  DEFAULT_RESEND_SECONDS,
  formatResendTimer,
  getNextVerificationStep,
} from "../../utils/verification";

// Step 1 of 2 at signup / login: verify the email code, then the phone OTP.
function VerifyEmail() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location?.state || {};

  const codeNotSent = state.emailCodeSent === false;
  const [code, setCode] = useState("");
  const [timer, setTimer] = useState(
    codeNotSent ? 0 : state.cooldownSeconds ?? DEFAULT_RESEND_SECONDS
  );
  const [error, setError] = useState(
    codeNotSent
      ? "We couldn't send the verification email. Please tap Resend code."
      : ""
  );
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (timer <= 0) return undefined;
    const id = setTimeout(() => setTimer((t) => t - 1), 1000);
    return () => clearTimeout(id);
  }, [timer]);

  if (!state.email) {
    return <Navigate to="/signin" replace />;
  }

  const verifyHandler = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    dispatch(doVerifyEmailCode({ email: state.email, code }))
      .then((res) => {
        if (getNextVerificationStep(res?.data) === "phone") {
          navigate("/verification", {
            state: {
              phoneNumber: state.phoneNumber || res?.data?.phoneNumber,
              email: state.email,
              from: state.from,
            },
            replace: true,
          });
        } else {
          toast.success("Email verified. Please sign in.");
          navigate("/signin", { replace: true });
        }
      })
      .catch((err) => {
        setError(err?.message || "Verification failed. Please try again.");
        setCode("");
      })
      .finally(() => setSubmitting(false));
  };

  const resendHandler = (e) => {
    e.preventDefault();
    setError("");
    setCode("");
    dispatch(doSendEmailCode({ email: state.email }))
      .then((res) => {
        toast.success("A new code has been sent to your email.");
        setTimer(res?.data?.cooldownSeconds ?? DEFAULT_RESEND_SECONDS);
      })
      .catch((err) => {
        setError(err?.message || "Could not send the code. Please try again.");
        if (err?.data?.cooldownSeconds) setTimer(err.data.cooldownSeconds);
      });
  };

  return (
    <section className="signin">
      <div className="container-main">
        <div className="signin-wrapper">
          <div className="signinSwiper">
            <Swiper />
            <SwiperText />
          </div>
          <CardSignin title="Verify your email">
            <form className="form" onSubmit={verifyHandler}>
              <ul>
                <li className="verification-step">Step 1 of 2: Email</li>
                <li className="verification-text">
                  <p>
                    We have sent a 6-digit code to
                    <span>{state.email}</span>
                  </p>
                </li>
              </ul>
              <ul>
                <li className="input-list">
                  <OtpInput
                    isInputNum={true}
                    value={code}
                    onChange={setCode}
                    numInputs={6}
                    shouldAutoFocus={true}
                    containerStyle={"otp-container"}
                    className="otp-input"
                    separator={<span></span>}
                  />
                </li>
                {timer > 0 && (
                  <li className="timer">
                    <div className="timer-wrap">
                      <img
                        src={toAbsoluteUrl("/images/timer.png")}
                        alt="timer"
                      />
                      <span>{formatResendTimer(timer)}</span>
                      <span>left</span>
                    </div>
                  </li>
                )}
              </ul>
              {error && (
                <h4
                  className="verification_error verification_error--sentence"
                  role="alert"
                  style={{ margin: "10px" }}
                >
                  {error}
                </h4>
              )}
              <ul>
                <li className="sign-btn">
                  {code.length === 6 && (
                    <button
                      type="submit"
                      className="buttonSubmit"
                      disabled={submitting}
                    >
                      Verify
                    </button>
                  )}
                </li>
                {timer <= 0 && (
                  <li className="verification-footer">
                    <h5>
                      Didn’t receive a code?
                      <button type="button" onClick={resendHandler}>
                        Resend code
                      </button>
                    </h5>
                  </li>
                )}
              </ul>
            </form>
          </CardSignin>
        </div>
      </div>
    </section>
  );
}

export default VerifyEmail;
